import React from "react"
import {formatTextTestIds} from "@next/utils"
import {CharacterLink} from "./components"

interface FacetsButtonProps {
    onClick: () => void
    text: string
    isClickable: boolean
    isSelectedCharacter?: boolean
}

export const Character = ({text, onClick, isClickable, isSelectedCharacter}: FacetsButtonProps) => (
    <CharacterLink
        disabled={!isClickable}
        selected={isSelectedCharacter}
        component="button"
        data-testid={formatTextTestIds(`character-link-${text}`)}
        onClick={onClick}
    >
        {text}
    </CharacterLink>
)

export default Character
